<template>
  <div class="page-container__flex">
    <div
      class="page-container__products category-products"
      :class="{ 'category-products--main-page': !cabinet, 'category-products--cabinet': cabinet }">
      <ul :class="{'category-products__waitlist-wrap' : isWaitList, 'category-products-wrap__item' : !isWaitList}">
        <template v-if="isWaitList">
          <li class="category-products__waitlist-card" v-for="(product, i) in itemsList" :key="product.id">
            <WaitListCard
              @onIntersecting="$emit('cardInViewportEvent', $event)"
              :position="i + 1"
              :id="Number(product.id)"
              :code="product.code.toString()"
              :title="product.title"
              :title-ru="product.title_anal"
              :link="product.link"
              :image-url="computedImageUrl(product)"
              :second-image-url="computedSecondImageUrl(product)"
              :rating="product.rating ? product.rating : ''"
              :reviews-count="Number(product.reviews_count)"
              :price="JSON.stringify({ 'price_new': computedPriceNew(product), 'price_old': computedPriceOld(product) })"
              :is-available="!!Number(product.is_available)"
              :is-novelty="!!Number(product.is_novelty)"
              :is-in-wait-list="!!Number(product.is_in_wait_list)"
              :in-stock="product.in_stock"
              :badges="JSON.stringify(product.badges)"
              :characteristics="product.characteristics.length ? product.characteristics : []"
              :arrival-date="product.arrival_date"
              :arrival-date-employee="product.arrival_date_employee"
              :category-id="product.category_id"
              :category-parent-id="product.category_parent_id"
              :options="product.options"
              :bottom-badge="product.bottom_badge"
              not-adaptive
              :block="blockName"
              :analytics-data="product.analytics_data"
              :available-in-store="product.available_only_in_store_data"
              :progressbar-total="product.progressbar_total"
              :progressbar-current="product.progressbar_current"
              :is-preorder="product.is_preorder"
            ></WaitListCard>
          </li>
        </template>
        <template v-else>
          <li class="category-products__card" v-for="(product, i) in itemsList" :key="product.id">
            <ProductCard
              @onIntersecting="$emit('cardInViewportEvent', $event)"
              :position="i + 1"
              :id="Number(product.id)"
              :code="product.code.toString()"
              :title="product.title"
              :title-ru="product.title_anal"
              :link="product.link"
              :image-url="computedImageUrl(product)"
              :second-image-url="computedSecondImageUrl(product)"
              :rating="product.rating ? product.rating : ''"
              :reviews-count="Number(product.reviews_count)"
              :price="JSON.stringify({ 'price_new': computedPriceNew(product), 'price_old': computedPriceOld(product) })"
              :is-available="!!Number(product.is_available)"
              :is-novelty="!!Number(product.is_novelty)"
              :is-in-wait-list="!!Number(product.is_in_wait_list)"
              :is-in-wish-list="!!Number(product.is_in_wish_list)"
              :in-stock="product.in_stock"
              :badges="JSON.stringify(product.badges)"
              :characteristics="product.characteristics.length ? product.characteristics : []"
              :arrival-date="product.arrival_date"
              :arrival-date-employee="product.arrival_date_employee"
              :category-id="product.category_id"
              :category-parent-id="product.category_parent_id"
              :options="product.options"
              :bottom-badge="product.bottom_badge"
              not-adaptive
              :block="blockName"
              adaptive-main-page
              :analytics-data="product.analytics_data"
              :available-in-store="product.available_only_in_store_data"
              :progressbar-total="product.progressbar_total"
              :progressbar-current="product.progressbar_current"
              :is-preorder="product.is_preorder"
            />
          </li>
        </template>
        <li class="observer" ref="observer"></li>
        <template v-if="isWaitList">
          <content-loader
            class="category-products__waitlist-card waitlist-card--skeleton-desktop"
            v-for="index in shownSkeletons"
            :key="index"
            :height="148"
            :width="512"
            :speed="2"
            primaryColor="#f3f3f3"
            secondaryColor="#ecebeb"
          >
            <rect x="15"
                  y="15"
                  rx="3"
                  ry="3"
                  width="108"
                  height="108" />
            <rect x="153"
                  y="15"
                  rx="3"
                  ry="3"
                  width="280"
                  height="24" />
            <rect x="478"
                  y="15"
                  rx="3"
                  ry="3"
                  width="20"
                  height="20" />
            <rect x="153"
                  y="52"
                  rx="3"
                  ry="3"
                  width="220"
                  height="18" />
            <rect x="153"
                  y="86"
                  rx="3"
                  ry="3"
                  width="215"
                  height="40" />
          </content-loader>
        </template>
        <template v-else>
          <content-loader
            class="category-products__card category-products__card--skeleton category-products__card--skeleton-mobile--main-page"
            v-for="index in shownSkeletons"
            :key="'main-page-mobile-' + index"
            :width="120"
            :height="211"
            :speed="2"
            primaryColor="#f3f3f3"
            secondaryColor="#ecebeb"
          >
            <rect x="0"
                  y="0"
                  rx="5"
                  ry="5"
                  width="120"
                  height="120" />
            <rect x="0"
                  y="129"
                  rx="3"
                  ry="3"
                  width="99"
                  height="16" />
            <rect x="0"
                  y="150"
                  rx="3"
                  ry="3"
                  width="120"
                  height="16" />
            <rect x="0"
                  y="191"
                  rx="3"
                  ry="3"
                  width="67"
                  height="20" />
            <rect x="90"
                  y="181"
                  rx="3"
                  ry="3"
                  width="30"
                  height="30" />
          </content-loader>
          <content-loader
            class="category-products__card category-products__card--skeleton category-products__card--skeleton-desktop"
            v-for="index in shownSkeletons"
            :key="index"
            :height="380"
            :width="278"
            :speed="2"
            primaryColor="#f3f3f3"
            secondaryColor="#ecebeb"
          >
            <rect x="30"
                  y="10"
                  rx="13"
                  ry="13"
                  width="220"
                  height="220" />
            <rect x="20"
                  y="271"
                  rx="3"
                  ry="3"
                  width="238"
                  height="13" />
            <rect x="20"
                  y="290"
                  rx="3"
                  ry="3"
                  width="123"
                  height="13" />
            <rect x="20"
                  y="337"
                  rx="3"
                  ry="3"
                  width="90"
                  height="24" />
          </content-loader>
          <content-loader
            class="category-products__card category-products__card--skeleton category-products__card--skeleton-mobile"
            v-for="index in shownSkeletons"
            :key="'mobile' + index"
            :height="130"
            :speed="2"
            primaryColor="#f3f3f3"
            secondaryColor="#ecebeb"
          >
            <rect x="85"
                  y="103"
                  rx="0"
                  ry="0"
                  width="81"
                  height="0" />
            <rect x="10"
                  y="13"
                  rx="13"
                  ry="13"
                  width="100"
                  height="100" />
            <rect x="126"
                  y="14"
                  rx="3"
                  ry="3"
                  width="240"
                  height="13" />
            <rect x="126"
                  y="38"
                  rx="3"
                  ry="3"
                  width="133"
                  height="13" />
            <rect x="18"
                  y="57"
                  rx="0"
                  ry="0"
                  width="2"
                  height="0" />
            <rect x="128"
                  y="94"
                  rx="3"
                  ry="3"
                  width="110"
                  height="20" />
            <rect x="345"
                  y="95"
                  rx="3"
                  ry="3"
                  width="20"
                  height="20" />
          </content-loader>
        </template>
        <li class="category-products__card category-products__card--btn" v-if="notObserve && mainPage">
          <Button @click.native="startObserve" type="plain">{{ $t('main_show_more') }}</Button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'
import Button from '../inputs/Button'
import ProductCard from '@/components/product/product-card/ProductCard'
import WaitListCard from '@/components/product/product-card/WaitListCard.vue'

export default {
  name: 'InfiniteScroll',
  components: {
    Button,
    ContentLoader,
    ProductCard,
    WaitListCard
  },
  props: {
    isWaitList: {
      type: Boolean,
      default: false
    },
    itemsList: {
      type: Array,
      required: true
    },
    getInfoAction: {
      type: Function,
      required: true
    },
    goodsLeft: {
      type: Number,
      required: true
    },
    offset: {
      type: Number,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    actionParams: {
      type: [Object, String]
    },
    mainPage: {
      type: Boolean,
      default: false
    },
    cabinet: {
      type: Boolean,
      default: false
    },
    productPage: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      shownSkeletons: 20,
      notObserve: true
    }
  },
  computed: {
    blockName () {
      return this.mainPage ? 'speciality' : this.productPage ? 'cross-sale-product-tab' : ''
    },
    computedImageUrl () {
      return (product) => product.photos?.image_url || product.image_url
    },
    computedSecondImageUrl () {
      return (product) => product.photos?.image_url_additional || product.second_image_url
    },
    computedPriceNew () {
      return (product) => +product.price?.price_new || +product.price_new
    },
    computedPriceOld () {
      return (product) => +product.price?.price_old || +product.price_old
    }
  },
  watch: {
    itemsList: {
      immediate: true,
      handler (value) {
        if (!value.length) {
          this.shownSkeletons = 20
        } else {
          this.shownSkeletons = 0
        }
      }
    }
    // itemsList (value) {
    //   if (!value.length) {
    //     this.shownSkeletons = 20
    //   } else {
    //     this.shownSkeletons = 0
    //   }
    // }
    // offset () {
    //   const { top, bottom } = this.$refs.observer.getBoundingClientRect()
    //   if (
    //     top >= 0 &&
    //     bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    //     this.goodsLeft &&
    //     !this.isLoading &&
    //     !this.notObserve
    //   ) {
    //     this.shownSkeletons = 20
    //     this.getInfoAction(this.actionParams)
    //   }
    // }
  },
  methods: {
    startObserve () {
      this.notObserve = false

      const observer = new IntersectionObserver(([entry]) => {
        if (entry && entry.isIntersecting && !this.isLoading && this.goodsLeft) {
          this.shownSkeletons = 20
          this.getInfoAction(this.actionParams)
        }
      })
      observer.observe(this.$refs.observer)
    }
  },
  mounted () {
    if (!this.mainPage) this.startObserve()
  }
}
</script>

<style scoped lang="sass">
.waitlist-card--skeleton-desktop
  border: 1px solid #F3F3F3
.category-products__waitlist-wrap
  display: flex
  justify-content: space-between
  flex-wrap: wrap
  width: 100%
  list-style: none
  margin: 0
  padding: 0
  .observer
    width: 100%
.category-products__waitlist-card
  width: calc(50% - 7px)
  flex-grow: 0
  flex-shrink: 0
  margin-bottom: 20px
  +mmax($tablet)
    width: 100%

.category-products--main-page
  margin-bottom: 0

  .category-products__card--skeleton-mobile
    display: none

  .category-products__card--skeleton-mobile--main-page
    padding: 15px 10px
    display: block

    +mmin($tablet)
      display: none

.category-products__card--skeleton-mobile--main-page
  display: none

.category-products__card--skeleton-mobile
  display: block
  border-bottom: 1px solid #ededed
  height: 230px

  +mmin($tablet)
    display: none

.category-products__card--skeleton-desktop
  display: none

  +mmin($tablet)
    display: block

.category-products__card--btn
  width: 100%
  border: none!important
  align-self: center
  padding: 40px 0
  margin: 0 -1px
  background-color: $white-text-color

  button
    margin: 0 auto

.observer
  //width: 100%
</style>
